import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { EarnStackRoutes, EarnStackScreenProps } from '../../earn.navigator';
import { ModalContainerView } from './ModalContainerView';
import { SubscribeConfirm } from './SubscribeConfirm';
import { SubscribeEdit } from './SubscribeEdit';
import { SubscribeResult } from './SubscribeResult';

import { SubscribeStackParamList, SubscribeStackRoutes } from './type';

const SubscribeStack = createNativeStackNavigator<SubscribeStackParamList>();

export const SubscribeNavigator: React.FC<EarnStackScreenProps<EarnStackRoutes.Subscribe>> = ({ route }) => {
  const { offerId } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <SubscribeStack.Navigator
          initialRouteName={SubscribeStackRoutes.Main}
          screenOptions={{
            presentation: 'modal',
            headerShown: false,
            contentStyle: {
              backgroundColor: 'transparent'
            }
          }}>
          <SubscribeStack.Screen
            name={SubscribeStackRoutes.Main}
            component={SubscribeEdit}
            initialParams={{ offerId, onLayout }}
            options={{ headerShown: false }}
          />
          <SubscribeStack.Screen
            name={SubscribeStackRoutes.Confirm}
            component={SubscribeConfirm}
            initialParams={{ offerId, onLayout }}
            options={{ presentation: layout.isMobile ? 'transparentModal' : 'modal', headerShown: false }}
          />
          <SubscribeStack.Screen
            name={SubscribeStackRoutes.Result}
            component={SubscribeResult}
            initialParams={{ offerId, onLayout }}
            options={{
              headerShown: false,
              presentation: 'modal'
            }}
          />
        </SubscribeStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
